import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import proxyConfig from './proxies/_config'

// Usa Bootstrap
import './assets/css/bootstrap.min.css'
import './assets/bootstrap-icons/bootstrap-icons.css'

import Vue3ProgressBar from "@ctechhindi/vue3-progress-bar";
import Toaster from '@meforma/vue-toaster';
import { createEarthoOne } from '@eartho/one-client-vue';
import 'gitart-vue-dialog/dist/style.css'
import { GDialog } from 'gitart-vue-dialog'
import 'ag-grid-enterprise';

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'

const app = createApp(App)

app.config.globalProperties.$proxies = proxyConfig;
app.provide('$proxies', app.config.globalProperties.$proxies) 

app.use(Toaster).provide('toast', app.config.globalProperties.$toast);

const options = {
  height: '5px',
  "customStyle": {
       width: "100 %",
       height: "100 %",
       position: "absolute",
       left: "0 %",
     },
};

app.component('VueDatePicker', VueDatePicker);

app.use(
  createEarthoOne({
    client_id: 'uV0oXGCNTlMOKaXyw0Kn',
  })
);
app.use(VuePlyr, {
  plyr: {}
})
app.component('GDialog', GDialog)
import router from './router'
app.use(store)
app.use(Vue3ProgressBar, options)
app.use(Toaster)
  app.use(router)
  app.mount('#app')